"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteringHierachyAssemblerImpl = void 0;
var HierarchyAssembler_1 = require("./HierarchyAssembler");
var FilteringHierachyAssemblerImpl = /** @class */ (function () {
    function FilteringHierachyAssemblerImpl(filterFunction) {
        this.filterFunction = filterFunction;
    }
    FilteringHierachyAssemblerImpl.prototype.assembleChildren = function (rootItem, content) {
        var _a;
        var _this = this;
        (_a = rootItem.children).push.apply(_a, content
            .filter(function (contentItem) {
            return ((0, HierarchyAssembler_1.isParent)(rootItem.content, contentItem.content) &&
                _this.filterFunction(contentItem.content));
        })
            .map(function (item) {
            var hierarchyItem = {
                content: item.content,
                children: [],
            };
            _this.assembleChildren(hierarchyItem, content);
            return hierarchyItem;
        }));
    };
    FilteringHierachyAssemblerImpl.prototype.assembleRoot = function (rootItem, content) {
        var _this = this;
        var rootHierarchyItem = {
            content: rootItem.toJSON(),
            children: [],
        };
        rootHierarchyItem.children = content
            .filter(function (contentItem) {
            return ((0, HierarchyAssembler_1.isParent)(rootItem.body, contentItem.content) &&
                !_this.filterFunction(contentItem.content));
        })
            .map(function (item) {
            var hierarchyItem = {
                content: item.content,
                children: [],
            };
            _this.assembleChildren(hierarchyItem, content);
            return hierarchyItem;
        });
        return rootHierarchyItem;
    };
    return FilteringHierachyAssemblerImpl;
}());
exports.FilteringHierachyAssemblerImpl = FilteringHierachyAssemblerImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmlsdGVyaW5nSGllcmFjaHlBc3NlbWJsZXJJbXBsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9jb250ZW50L2Nvb3JkaW5hdG9ycy9HZXRCeUhpZXJhcmNoeS9hc3NlbWJsZXJzL0ZpbHRlcmluZ0hpZXJhY2h5QXNzZW1ibGVySW1wbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwyREFBb0U7QUFRcEU7SUFFRSx3Q0FBNkIsY0FBMEM7UUFBMUMsbUJBQWMsR0FBZCxjQUFjLENBQTRCO0lBQUcsQ0FBQztJQUMzRSx5REFBZ0IsR0FBaEIsVUFDRSxRQUFvQyxFQUNwQyxPQUF5Qzs7UUFGM0MsaUJBcUJDO1FBakJDLENBQUEsS0FBQSxRQUFRLENBQUMsUUFBUSxDQUFBLENBQUMsSUFBSSxXQUNqQixPQUFPO2FBQ1AsTUFBTSxDQUFDLFVBQUMsV0FBVztZQUNsQixPQUFPLENBQ0wsSUFBQSw2QkFBUSxFQUFDLFFBQVEsQ0FBQyxPQUFPLEVBQUUsV0FBVyxDQUFDLE9BQU8sQ0FBQztnQkFDL0MsS0FBSSxDQUFDLGNBQWMsQ0FBQyxXQUFXLENBQUMsT0FBTyxDQUFDLENBQ3pDLENBQUM7UUFDSixDQUFDLENBQUM7YUFDRCxHQUFHLENBQUMsVUFBQyxJQUFJO1lBQ1IsSUFBTSxhQUFhLEdBQThCO2dCQUMvQyxPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU87Z0JBQ3JCLFFBQVEsRUFBRSxFQUFFO2FBQ2IsQ0FBQztZQUNGLEtBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxhQUFhLEVBQUUsT0FBTyxDQUFDLENBQUM7WUFDOUMsT0FBTyxhQUFhLENBQUM7UUFDdkIsQ0FBQyxDQUFDLEVBQ0o7SUFDSixDQUFDO0lBRUQscURBQVksR0FBWixVQUNFLFFBQTJCLEVBQzNCLE9BQXlDO1FBRjNDLGlCQXlCQztRQXJCQyxJQUFNLGlCQUFpQixHQUErQjtZQUNwRCxPQUFPLEVBQUUsUUFBUSxDQUFDLE1BQU0sRUFBRTtZQUMxQixRQUFRLEVBQUUsRUFBRTtTQUNiLENBQUM7UUFDRixpQkFBaUIsQ0FBQyxRQUFRLEdBQUcsT0FBTzthQUNqQyxNQUFNLENBQUMsVUFBQyxXQUFXO1lBQ2xCLE9BQU8sQ0FDTCxJQUFBLDZCQUFRLEVBQUMsUUFBUSxDQUFDLElBQUksRUFBRSxXQUFXLENBQUMsT0FBTyxDQUFDO2dCQUM1QyxDQUFDLEtBQUksQ0FBQyxjQUFjLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUMxQyxDQUFDO1FBQ0osQ0FBQyxDQUFDO2FBQ0QsR0FBRyxDQUFDLFVBQUMsSUFBSTtZQUNSLElBQU0sYUFBYSxHQUErQjtnQkFDaEQsT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPO2dCQUNyQixRQUFRLEVBQUUsRUFBRTthQUNiLENBQUM7WUFDRixLQUFJLENBQUMsZ0JBQWdCLENBQUMsYUFBYSxFQUFFLE9BQU8sQ0FBQyxDQUFDO1lBQzlDLE9BQU8sYUFBYSxDQUFDO1FBQ3ZCLENBQUMsQ0FBQyxDQUFDO1FBRUwsT0FBTyxpQkFBaUIsQ0FBQztJQUMzQixDQUFDO0lBQ0gscUNBQUM7QUFBRCxDQUFDLEFBcERELElBb0RDO0FBcERZLHdFQUE4QiJ9